export const DELIVERY_PROVIDERS = ['yandex', 'choco', 'wolt'] as const;

export type DeliveryProviderName = (typeof DELIVERY_PROVIDERS)[number];

export interface DeliveryProvider {
  provider: DeliveryProviderName;
  enabled: boolean;
}

export interface SettingsPageState {
  getConfig: {
    data: any;
    loading: boolean;
    error: null | string;
  };
  getCardPayment: {
    data: any;
    loading: boolean;
    error: null | string;
  };
  getGlovoEnabledStatus: {
    data: any;
    loading: boolean;
    error: null | string;
  };
  getDeliveryProviders: {
    data: DeliveryProvider[] | null;
    loading: boolean;
    error: null | string;
  };
}
